import { render, staticRenderFns } from "./createCustomConcept.vue?vue&type=template&id=67d3891f"
import script from "./createCustomConcept.vue?vue&type=script&lang=ts"
export * from "./createCustomConcept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./createCustomConcept.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxButtonPrimary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Primary.vue').default,IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxFormInputConceptCombobox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/ConceptCombobox.vue').default,EsgActionsTable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/ActionsTable.vue').default,IxDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Dialog.vue').default})
